<template>
    <ReactPage>
      <user-task-response-transaction-report-page></user-task-response-transaction-report-page>
    </ReactPage>
  </template>
  
  <script>
  import ReactPage from '../components/ReactPage.vue';
  
  export default {
    name: "UserTaskResponseTransactionReport",
    components: {
      ReactPage
    }
  }
  </script>